import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import Loading from 'components/commons/loading/Loading';

export const DuplicationAccountDeleteModal = ({
  isShow,
  isLoading,
  hide,
  doDeleteOKMono,
}: {
  isShow: boolean;
  isLoading: boolean;
  hide: () => void;
  doDeleteOKMono: () => void;
}) => {
  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto text-bluegray-700">
        <div className="flex flex-row">
          <div className="icon-alert items-start mr-2 mt-1 text-upcolor"></div>
          <div className="font-bold text-base">同じ口座を登録しています</div>
          <div
            className="icon-close ml-auto text-gray-500 cursor-pointer"
            onClick={hide}
          />
        </div>
        <div className="mt-4 text-sm">
          こちらの口座はすでに登録されています。
          <br />
          アセプラでは同一口座を登録できませんので、削除をお願いします。
        </div>
        <div className="mt-4 text-xs">
          ※口座削除後、資産総額やチャートに影響がある可能性があります。
        </div>
        <div className="flex flex-col items-center">
          <button
            className="w-full flex justify-center mt-6 py-3 text-base text-white bg-tradewell rounded-lg"
            onClick={doDeleteOKMono}
            disabled={isLoading}>
            {isLoading ? (
              <Loading
                loading
                circularLoading
                style={{ width: '45px', height: '27px' }}
              />
            ) : (
              '口座を削除する'
            )}
          </button>
          <button
            onClick={hide}
            className="flex justify-center text-gray-500 mt-2 p-4 text-base">
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
